import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-citation-information",
  templateUrl: "./citation-information.component.html",
  styleUrls: ["./citation-information.component.scss"],
})
export class CitationInformationComponent implements OnInit {
  @Input() authors: string[];
  @Input() year: string;
  @Input() title: string;
  @Input() from?: string;

  constructor() {}

  ngOnInit() {}
}
